import { render } from "./top-blog.vue?vue&type=template&id=24a06c50&scoped=true"
import script from "./top-blog.vue?vue&type=script&lang=js"
export * from "./top-blog.vue?vue&type=script&lang=js"

import "./top-blog.vue?vue&type=style&index=0&id=24a06c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a06c50"]])

export default __exports__